package gr.tech.GRAttestation.infrastructure.api

import gr.tech.GRAttestation.models.api.ApiError
import gr.tech.GRAttestation.models.api.ApiResponse
import gr.tech.GRAttestation.models.api.PaginatedResult
import gr.tech.GRAttestation.models.attestation.AttestationDTO
import gr.tech.GRAttestation.models.attestation.AttestationForm
import gr.tech.GRAttestation.models.attestation.SubmitAttestationForm
import gr.tech.GRAttestation.models.tables.BasicTableFilters
import gr.tech.GRAttestation.util.ROUTES
import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.serialization.json.Json
import org.w3c.fetch.INCLUDE
import org.w3c.fetch.RequestCredentials
import org.w3c.fetch.RequestInit
import org.w3c.files.Blob
import org.w3c.xhr.FormData

// CREATE
suspend fun saveUserPDFWithUserStoreId(
    attestation: AttestationForm,
    pdfBlob: Blob,
    repName: String,
    storeName: String,
): ApiResponse<Unit> {
    val json = Json { encodeDefaults = true }
    val formData = FormData()
    formData.append("attestationFormData", json.encodeToString(
        SubmitAttestationForm(
            salesData = attestation.salesDataList,
            repSignDate = attestation.repSignDate,
            reportingMonth = attestation.reportingMonth,
            repName = repName,
            acceptedTerms = attestation.acceptedTerms,
        )
    ))
    formData.append("pdf", pdfBlob, "${storeName.replace(" ", "")}-${attestation.repSignDate}")

    return safeApiCallFormData(
        url = ROUTES.BACKEND.FORMS.FORMS,
        formData = formData
    )
}


// READ
suspend fun adminFetchAttestationsByStoreID(
    storeId: String,
    pageNumber: Int,
    pageSize: Int,
    basicFilters: BasicTableFilters,
    onResponse: (ApiResponse<PaginatedResult<AttestationDTO>>) -> Unit,
    onError: (String) -> Unit,
) {
    val urlWithParameters = ROUTES.BACKEND.FORMS.ADMIN_FORMS +
            "?id=${storeId}" +
            "&page=$pageNumber&pageSize=$pageSize" +
            "&dateColumn=${basicFilters.dateColumn}" +
            "&asc=${basicFilters.isAscending}" +
            "&before=${basicFilters.isBefore}" +
            "&date=${basicFilters.dateString}"

    try {
        val result: ApiResponse<PaginatedResult<AttestationDTO>> = safeApiCallStringBody(
            url = urlWithParameters,
            method = "GET",
        )

        onResponse(result)
    } catch (e: Exception) {
        onError("failed to adminFetchAttestationsByStoreID(): $e")
        return
    }
}

suspend fun fetchAttestationsWithUserStoreId(
    pageNumber: Int,
    pageSize: Int,
    onResponse: (ApiResponse<PaginatedResult<AttestationDTO>>) -> Unit,
    onError: (String) -> Unit,
) {
    val urlWithParameters = ROUTES.BACKEND.FORMS.FORMS +
            "?page=$pageNumber&pageSize=$pageSize"

    try {
        val result: ApiResponse<PaginatedResult<AttestationDTO>> = safeApiCallStringBody(
            url = urlWithParameters,
            method = "GET",
        )

        onResponse(result)
    } catch (e: Exception) {
        onError("failed to fetchAttestationsWithUserStoreId(): $e")
        return
    }
}

suspend fun adminFetchFormsSummary(
    onResponse: (ApiResponse<List<AttestationDTO>>) -> Unit,
    onError: (String) -> Unit,
) {
    try {
        val result: ApiResponse<List<AttestationDTO>> = safeApiCallStringBody(
            url = ROUTES.BACKEND.FORMS.ADMIN_FORMS_SUMMARY,
            method = "GET",
        )
        onResponse(result)
    } catch (e: Exception) {
        onError("failed to adminFetchAllProjects(): $e")
        return
    }
}

// DELETE
suspend fun adminDeleteAttestationByID(
    attestationId: Int,
    restore: Boolean = false,
    onResponse: (ApiResponse<Boolean>) -> Unit,
    onError: (String) -> Unit,
) {
    var url = "${ROUTES.BACKEND.FORMS.ADMIN_FORMS_DELETE}/$attestationId"
    if (restore) url += "/restore"

    val method = if (restore) "PUT" else "DELETE"

    try {
        val result: ApiResponse<Boolean> = safeApiCallStringBody(
            url = url,
            method = method,
        )

        onResponse(result)
    } catch (e: Exception) {
        onError("Failed to adminDeleteAttestationByID()")
        return
    }
}